module.exports = __webpack_public_path__ + "img/big2.c660dafd.png";